import { Component } from 'react';
import { API_ENDPOINT } from '../../constants';
import ListBuilder from '../../components/listBuilder';
import Page from '../../containers/page';
import { updateParamsHelper, getParamsFromURL } from '../../helpers/custom.helper';
import { Container, Row, Col } from 'reactstrap';

class PatientPrescriptionListLogs_SWEDEN extends Component {
    constructor(props) {
        super(props);
        this.state = {
            total: 0,
            params: {
                entries: 10,
                page: 0,
                sortField: 'tsCreated',
                sortType: -1,
                filter: '',
            },
            loading: true,
            initialList: [],
            error: null,
            statusFilter: '',
            modified: 'Not modified'.translate(this.props.lang),
        };
    }

    get = async () => {
        this.setState({
            loading: true,
            initialList: [],
            modified: 'Not modified'.translate(this.props.lang),
        });

        try {
            const response = await fetch(
                `${API_ENDPOINT}/e-receipt/sweden/patientPrescriptionListLogs/get`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
                    },
                    body: JSON.stringify({
                        groupAlias: localStorage.getItem('groupAlias'),
                        groupId: this.props._groupId || null,
                        patientId: this.props.patientId,
                        total: this.state.total,
                        entries: this.state.params?.entries,
                        page: this.state.params?.page,
                        sortField: this.state.params?.sortField,
                        sortType: this.state.params?.sortType,
                        filter: this.state.params?.filter,
                        statusFilter: this.state.statusFilter
                    }),
                }
            );

            const data = await response.json();

            if (data.items) {
                const newState = {
                    loading: false,
                    initialList: data.items,
                    total: data.total,
                };

                if (data.tsModified) {
                    const modified = this.props.getStringDateTs?.(
                        data.tsModified,
                        this.props.dateFormat
                    );
                    if (modified) newState.modified = modified.translate(this.props.lang);
                }

                this.setState(newState);
            } else {
                const errState = {
                    loading: false,
                    modified: 'Not modified'.translate(this.props.lang),
                };

                if (data.error) {
                    errState.error = data.error;
                }

                this.setState(errState);
            }
        } catch (err) {
            this.setState({
                loading: false,
                error: err?.message || 'Error fetching prescription list logs for Sweden',
            });
        } finally {
            this.setState({ loading: false });
        }
    };

    componentDidMount() {
        const urlParams = getParamsFromURL();

        const newParams = {
            ...this.state.params,
            entries: urlParams.entries,
            filter: urlParams.filter,
        };

        this.setState({ params: newParams }, () => {
            if (this.props.initialList) {
                this.setState({
                    loading: false,
                    initialList: this.props.initialList,
                });
            } else {
                this.get();
            }
        });
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.patientId !== this.props.patientId ||
            prevProps._groupId !== this.props._groupId ||
            prevProps.view !== this.props.view
        ) {
            this.setState({
                loading: true,
                initialList: [],
                modified: 'Not modified'.translate(this.props.lang),
            });

            this.get();
        }
    }

    updateSort = (field, type) => {
        updateParamsHelper(this, { sortField: field, sortType: type });
    };

    updateParams = (name, value, restart = false) => {
        updateParamsHelper(this, { [name]: value }, restart);
    };

    updateMultipleParams = (fields, restart = false) => {
        updateParamsHelper(this, fields, restart);
    };

    render() {
        let params = this.state.params;

        return (
            <div className={this.props.autoHideSidebar ? "dashboard dashboard-auto-hide" : "dashboard"}>
                <Container fluid>
                    <Row>
                        <Col lg='12'>
                            <div className='panel aeb-panel'>
                                <div className='panel-header'>
                                    <h5 className='component-header'>
                                        {'Prescription list logs - Sweden'.translate(this.props.lang)}
                                    </h5>

                                </div>

                                <select
                                    value={this.state.statusFilter}
                                    onChange={(e) => this.setState({ statusFilter: e.target.value }, () => this.get())}
                                    className="patientPrescriptionListLogsSweden-filter"
                                >
                                    <option value=''>{'All'.translate(this.props.lang)}</option>
                                    <option value='SUCCESS'>{'Success'.translate(this.props.lang)}</option>
                                    <option value='FAILED'>{'Failed'.translate(this.props.lang)}</option>
                                </select>

                                <ListBuilder
                                    lang={this.props.lang}
                                    loading={this.state.loading}
                                    total={this.state.total}
                                    hideEntries={false}
                                    showNumeration={false}
                                    fields={[
                                        { type: 'text', label: 'Endpoint/File'.translate(this.props.lang), name: 'endpoint' },
                                        { type: 'text', label: 'Type'.translate(this.props.lang), name: 'type' },
                                        { type: 'text', label: 'Status'.translate(this.props.lang), name: 'status' },
                                        { type: 'text', label: 'Created at'.translate(this.props.lang), name: 'tsCreatedFormatted' },
                                        { type: 'text', label: 'Doctor id'.translate(this.props.lang), name: 'doctorId' },
                                        { type: 'text', label: 'Patient id'.translate(this.props.lang), name: 'patientId' },
                                        // { type: 'text', label: 'Group id'.translate(this.props.lang), name: 'groupId' },
                                        { type: 'text', label: 'Session guid'.translate(this.props.lang), name: 'sessionGuid' },
                                        { type: 'text', label: 'Ticket'.translate(this.props.lang), name: 'ticket' },
                                        { type: 'text', label: 'Cron id'.translate(this.props.lang), name: 'cronId' },
                                        { type: 'text', label: 'Prescription id'.translate(this.props.lang), name: 'prescriptionId' },
                                        { type: 'text', label: 'Error type'.translate(this.props.lang), name: 'errorType' },
                                        { type: 'text', label: 'Message'.translate(this.props.lang), name: 'errorMessage' },  // error/success
                                        { type: 'text', label: 'Raw response'.translate(this.props.lang), name: 'rawResponse' },
                                    ]}
                                    items={this.state?.initialList?.map((item) => {
                                        const formatTs = (ts) => {
                                            if (!ts) return '-';
                                            return new Date(ts * 1000).toLocaleString('sv-SE');
                                        };
                                        return {
                                            ...item,
                                            endpoint: (
                                                <div style={{ fontWeight: 600 }}>{item?.endpoint}</div>
                                            ),
                                            type: (
                                                <div style={{ fontWeight: 600 }}>{item?.type}</div>
                                            ),
                                            status: (
                                                <div className={`patientPrescriptionListLogs-status-${item?.status === 'SUCCESS' ? 'success' : 'failed'}`}>
                                                    {item?.status}
                                                </div>
                                            ),
                                            tsCreatedFormatted: formatTs(item?.tsCreated),
                                        };
                                    })}
                                    actions={[]}
                                    rawItems={this.state.items}
                                    params={params}
                                    sortField={params.sortField}
                                    sortType={params.sortType}
                                    updateSort={this.updateSort}
                                    updateParams={this.updateParams}
                                    updateMultipleParams={this.updateMultipleParams}
                                />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

export default Page(PatientPrescriptionListLogs_SWEDEN);